namespace TabAurous.Production {
    export namespace JobWorkDismantlingItemsService {
        export const baseUrl = 'Production/JobWorkDismantlingItems';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DismantlingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/JobWorkDismantlingItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JobWorkDismantlingItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
